export enum BannerNotificationType {
  FREE_PLAN_USAGE_EXCEEDED = 'FREE_PLAN_USAGE_EXCEEDED',
}
